export default __webpack_public_path__ + "static/media/ClientPin.1e4e8cc6.svg";